import { exchangeRefreshToken } from './refreshToken';
import { clearSession, isExpiringWithin, setSessionExpiry } from './session';

// Singleton promise so concurrent callers share one /auth/refresh round-trip.
// Refresh-token rotation (e.g. Okta) makes a second parallel refresh fatal.
let refreshPromise: Promise<boolean> | null = null;

async function doRefresh(): Promise<boolean> {
  const tokenData = await exchangeRefreshToken();
  if (!tokenData) {
    clearSession();
    return false;
  }
  const nowSec = Math.floor(Date.now() / 1000);
  setSessionExpiry(nowSec + tokenData.expires_in);
  return true;
}

/**
 * Ensure the cookie session is fresh. Refreshes when the expiry hint is missing
 * or within the 30s buffer; pass `force` (after a 401) to refresh even when the
 * hint still reads fresh — the cookie may be revoked/rotated/clock-skewed while
 * the hint disagrees. Single-flight: concurrent callers share one refresh.
 */
export async function ensureFreshSession(force = false): Promise<boolean> {
  if (refreshPromise) return refreshPromise;
  if (!force && !isExpiringWithin(30)) return true;

  refreshPromise = doRefresh();
  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}
